<template>
  <v-dialog v-model="dialog" max-width="480px">
    <v-card>
      <v-card-title class="mx-3">
        {{ title ? title : $t("Import.import", [objName]) }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-4 py-8 text-center subtitle-1">
        <v-list-item three-line>
          <v-list-item-content>
            <span v-if="downloadFromAPI || downloadTemplateUrl">
              <v-list-item-title class="text-left my-2">
                {{
                  template
                    ? template
                    : $t("Import.downloadFieldTemplate", [objName])
                }}
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-row v-if="downloadFromAPI">
                  <v-col cols="12" sm="8" md="8">
                    <v-autocomplete
                      v-model="categorySelected"
                      :items="items"
                      item-text="category_name"
                      item-value="category_code"
                      :label="$t('MaterialCategory.title')"
                      clearable
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="4" md="4" align-self="center">
                    <v-btn color="primary" dark class="ms-1" @click="$emit('download', categorySelected)">
                      {{ $t("Import.downloadFieldTemplateBtn") }}
                    </v-btn>
                  </v-col>
                </v-row>
                <v-btn
                  v-else
                  color="primary"
                  dark
                  class="ms-1"
                  :href="$BaseURL + downloadTemplateUrl"
                >
                  {{ $t("Import.downloadFieldTemplateBtn") }}
                </v-btn>
              </v-list-item-subtitle>
            </span>

            <v-list-item-title class="text-left my-2">
              {{ upload ? upload : $t("Import.uploadField", [objName]) }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <v-file-input
                v-model="excelFile"
                show-size
                :label="$t('Import.fileInputLabel')"
                accept=".xls,.xlsx"
              ></v-file-input>
            </v-list-item-subtitle>
            <span v-if="isTips">
              <v-list-item-title class="text-left my-2">
                {{ $t("$vuetify.alert") }}
              </v-list-item-title>
              <v-list-item-subtitle
                class="text-left my-1"
                v-for="detail in tipDetails"
                :key="detail"
              >
                {{ detail }}
              </v-list-item-subtitle>
            </span>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn color="primary" depressed @click="$emit('import', excelFile)">
          {{ $t("Import.confirmImport") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import MaterialCategories from "@/api/material_categories";
  export default {
  name: "ImportExcelDialog",

  props: {
    value: Boolean,
    title: String,
    objName: String,
    isTips: Boolean,
    tipDetails: Array,
    downloadFromAPI: Boolean,
    downloadTemplateUrl: String,
    template: String,
    upload: String,
  },

  data: () => ({
    dialog: false,
    excelFile: null,
    categorySelected: null,
    items: [],
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
        if (this.downloadFromAPI) {
          this.getMaterialCategoriesFromAPI()
        }
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.excelFile = null;
          this.categorySelected = null;
        }
        this.$emit("input", this.dialog);
      },
    },
  },
  methods: {
    getMaterialCategoriesFromAPI() {
      this.materialCategoriesLoading = true;
      MaterialCategories.getCategories()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.items = response.data.categories;
            }
            this.materialCategoriesLoading = false;
          }.bind(this)
        ).catch(
          function () {
            this.materialCategoriesLoading = false;
          }.bind(this)
      );
    },
  },
};
</script>